import React, { useCallback, useEffect, useRef, useState } from "react";
import { useIntl } from 'react-intl';
import { db } from "../../../db/db";
import { useLiveQuery } from 'dexie-react-hooks';
import ModalConfigs from '../../Modals/ModalConfigs';
import { DivSelectLangStyle } from "./styles";
import { useNavigate } from "react-router-dom";
import ModalEditAccount from "../../Modals/ModalEditAccount";
import ModalReviewTutorials from "../../Modals/ModalReviewTutorials";
import { editAccount, getTutorials } from "../../../services";
import { removeUser } from "../../../store/user/userSlice";
import { useDispatch } from "react-redux";

const SelectLang = () => {
  const navigate = useNavigate()
  const intl = useIntl();
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [showModalConfigs, setShowModalConfigs] = useState<boolean>(false);
  const [showModalEditAccount, setShowModalEditAccount] = useState<boolean>(false);
  const [showModalReviewTutorials, setShowModalReviewTutorials] = useState<boolean>(false);
  const dropdownEl = useRef<HTMLUListElement>(null);
  const userDb = useLiveQuery(() => db.user.toArray())
  const userConfigsDb = useLiveQuery(() => db.userConfigs.toArray())
  const companyDb = useLiveQuery(() => db.company.toArray())
  const dispatch = useDispatch();

  const handleClickOutSide = useCallback(
    (e) => {
      if (
        showDropdown &&
        e.target.closest(".dropdown") !== dropdownEl.current
      ) {
        setShowDropdown(false);
      }
    },
    [showDropdown, dropdownEl]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutSide);
    return () => {
      document.removeEventListener("click", handleClickOutSide);
    };
  }, [handleClickOutSide]);

  const editAccountHandler = () => {
    setShowModalEditAccount(true);
  };
  const configHandler = () => {
    setShowModalConfigs(true);
  };
  const tutorialsHandler = () => {
    setShowModalReviewTutorials(true);
  };

  const updateToken = () => {
    try {
      const submit = {
        user: {
          id: userDb![0].id,
          accessToken: null
        }
      }
      if (submit && userDb) {
        editAccount(submit, userDb[0].accessToken)
          .then(resp => {
          })
          .catch(error => {
            console.error(error);
          })
      }
    } catch (error) {
      console.error(error);
    }
  }

  const signOutHandler = () => {
    try {
      updateToken();
      db.user.clear();
      db.company.clear();
      dispatch(removeUser())
      localStorage.setItem('filters', '')
      localStorage.setItem('searchCookbook', '')
      setTimeout(function () {
        navigate('/login')
        window.location.reload()
      }, 50);
    } catch (error) {
      console.error(error)
    }
  };

  const handleConfirmReviewTutorials = useCallback(async () => {
    try {
      const id: number = (userConfigsDb ? (userConfigsDb[0]?.id ?? 1) : 1);
      const tutorialsDataResponse = await getTutorials(userDb?.[0]?.id ?? 1, userDb?.[0].accessToken ?? '');
      db.userConfigs.update(id, { id, tutorialsUnmade: tutorialsDataResponse.data });
    } catch (error) {
      console.error(error)
    }
  }, [userDb, userConfigsDb])

  return (
    <DivSelectLangStyle id="joyride-user-name">
      {showModalConfigs && (
        <div className="modal">
          <ModalConfigs onCancel={() => (setShowModalConfigs(false), setShowDropdown(!showDropdown))} userConfigsDb={userConfigsDb ? userConfigsDb[0] : ''} />
        </div>
      )}

      {showModalEditAccount && (
        <div className="modal">
          <ModalEditAccount user={userDb ? userDb[0] : ""} onCancel={() => setShowModalEditAccount(false)} />
        </div>
      )}

      {showModalReviewTutorials && (
        <div className="modal">
          <ModalReviewTutorials idUser={userDb?.[0]?.id ?? 0} token={userDb?.[0].accessToken ?? ''} onUpdateList={handleConfirmReviewTutorials} onCancel={() => setShowModalReviewTutorials(false)} />
        </div>
      )}

      <p className="selected" onClick={() => setShowDropdown(!showDropdown)}>
        <span>{userDb ? userDb[0].userName : ""}</span>
        <span className={showDropdown ? 'up-arrow' : 'down-arrow'}></span>
      </p>
      {showDropdown && (
        <ul className="dropdown" ref={dropdownEl}>
          <p>{companyDb && companyDb[0].corporateName}</p>
          <p>ID: {companyDb && companyDb[0].id}</p>
          <li className="notShowMobile" onClick={editAccountHandler}>{intl.formatMessage({ id: 'main.Editar conta' })}</li>
          <li className="notShowMobile" onClick={configHandler}>{intl.formatMessage({ id: 'main.Configurações' })}</li>
          {companyDb && (companyDb[0].companyType !== 'Suporte' && companyDb[0].companyType !== 'Master') && <li className="notShowMobile" onClick={tutorialsHandler}>{intl.formatMessage({ id: 'main.Rever tutoriais' })}</li>}
          <li className="notShowMobile" onClick={signOutHandler}>{intl.formatMessage({ id: 'navbar.logout' })}</li>
        </ul>
      )}
    </DivSelectLangStyle>
  );
};

export default SelectLang;
